import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { OverlayBatteryCertificate } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'BatteryCertificate',
    events: {
        'Load Battery Certificate': emptyProps(),
        'Load Battery Certificate Success': props<{ content: OverlayBatteryCertificate }>(),
        'Load Battery Certificate Failure': props<{ error: string }>(),
    },
});
